const state = () => ({
    resellerId: process.env.VUE_APP_RESELLER_ID,
    resellerInfo: require('../../assets/theme/' + process.env.VUE_APP_RESELLER_ID + '/reseller.json'), 
    master: require("../../assets/master.json"),
    groupResellerInfo: ''
});


const getters = {
    resellerId: state => state.resellerId,
    getMasterInfo: state => state.master,
    getResellerInfo: state => state.resellerInfo,
    getGroupReseller: state => state.groupResellerInfo
};

const mutations = {
    setResellerId (state, payload) {
      state.resellerId = payload
    },
    setGroupReseller (state, json) {
      state.groupResellerInfo = json
    }
  }
  
  const actions = {
    findGroupReseller (context, id) {        
      let json = require('../../assets/theme/' + id + '/reseller.json')  
      if (json) {
        context.commit('setGroupReseller', json)
      }
    }
  }
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}